import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import DashboardWidget from "features/quicksight/presentation/widgets/dashboard.widget";
import useGetAdhocDashboard from "hooks/quicksight/useGetAdhocDashboard";
import { AxiosBaseErrorContext } from "core/utils/baseError";
import paths from "paths";

/**
 * @typedef {Object} AdhocDashboardParams
 * @property {string} id
 * @property {string} contextId
 */
export type AdhocDashboardParams = {
    id: string;
    contextId: string;
}

const AdhocDashboardPage: React.FC = () => {
    const { id, contextId } = useParams() as AdhocDashboardParams;
    const result = useGetAdhocDashboard(id, contextId);
    const navigate = useNavigate();

    useEffect(() => {
        if (result.isError) {
            const context = result.error.context as AxiosBaseErrorContext;
            if (context.status === 422 || context.status === 403) {
                navigate(`/${paths.authenticated.DASHBOARD}`);
            }
        }
    }, [result.isError]);


    return (
        <DashboardWidget data={result.data} isLoading={result.isLoading} isError={result.isError} error={result.error} />
    )

}

export default AdhocDashboardPage;
